import httpClient from "./httpClient";
import { UserConfig } from "../types/users";

export const config = {
	get: async (userid: number): Promise<UserConfig | undefined> => {
		const response = await httpClient.get(`/users/${userid}/config`);
		return response.data as UserConfig;
	},
	update: async (config: UserConfig): Promise<UserConfig | undefined> => {
		const { userid } = config;
		const response = await httpClient.put(`/users/${userid}/config`, config);
		return response.data as UserConfig;
	}
};
